import { useState, FormEventHandler } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { confirmResetPassword, type ConfirmResetPasswordInput } from "aws-amplify/auth";

// Helpers
import { errorLogger } from "@/Common/helpers/logger";

// Components
import ResetPassword from "@Auth/Layouts/ResetPassword";
import { INITIAL_RESET_PASSWORD_STATE } from "../constants";

export default function ResetPasswordVerification() {
	const navigate = useNavigate();
	const { userName, code } = useParams();
	const [state, setState] = useState(INITIAL_RESET_PASSWORD_STATE);

	const routeChange = () => {
		navigate("/login");
	};

	const handleConfirmResetPassword = async ({
	  username,
	  confirmationCode,
	  newPassword
	}: ConfirmResetPasswordInput) => {
	  try {
		await confirmResetPassword({ username, confirmationCode, newPassword });
	  } catch (error) {
		setState({
		  ...state,
		  message: "An error occurred.",
		  error: true,
		});
	  }
	};

	const handleSubmit: FormEventHandler = (e) => {
		e.preventDefault();

		if (userName && code) {
			handleConfirmResetPassword({ username: userName, confirmationCode: code, newPassword: state.password });
			routeChange();
		} else {
			errorLogger("Username or confirmation code is missing.");
		}
	};

	return <ResetPassword title="Reset Password" state={state} handleSubmit={handleSubmit} updateState={setState} />;
}
